import React from "react";
import Title from "../title";
import Grid from "../Grid/grid";
import reactBenefits from "./data/react-js-benefit-data";
import bg from "../../Assets/image/services-pages-images/react-js-images/react-js-bg.webp"

function ReactJsBenefits() {
  return (
    <section className="w-full min-h-screen h-full relative flex flex-col overflow-hidden">
      <Grid size={100} direction="top-center" />
      <div className="p-2 lg:p-16 flex flex-col w-full items-center justify-center">
        <div className="z-10 flex justify-start items-start mb-12 w-full">
          <Title title="react js for software development" />
        </div>
        <h2 className="md:text-4xl text-xl font-medium md:font-light max-w-4xl text-center">
          Create seamless, interactive, and lightning-fast web applications with
          the power of React.js.
        </h2>
      </div>
      <div className="flex flex-col items-center justify-center">
        <div
          className="w-full bg-cover block mt-5"
          style={{
            backgroundImage: `url(${bg})`,
          }}
        >
          <div className="grid md:grid-cols-3 bg-black/60">
            {reactBenefits.map((data, index) => (
              <div className="p-12 border border-white flex flex-col gap-8 last:md:col-span-3">
                <div className="flex flex-row items-center gap-4">
                  <p className="font-bold text-6xl text-white">0{index + 1}</p>
                  <h2 className="text-white text-2xl">{data.title}</h2>
                </div>
                <div>
                  <p className="text-white text-lg">{data.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ReactJsBenefits;

